export const SITECORE_LAYOUT_ID_SLIDESHOW_MODAL =
  '2b99383c-7210-4fe9-87b4-e60190f99d89'

export const SITECORE_LAYOUT_ID_PART_DETAIL_PAGE =
  'f3eb93e2-c130-421b-9b93-e3efa5d79b93'

export const SITECORE_LAYOUT_ID_MAGAZINE_PAGE =
  'a6114366-1168-46f5-9587-c5afd70f3e35'
